import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withKeys as _withKeys, createCommentVNode as _createCommentVNode, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a529889"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "season-game-detail-wrapper" }
const _hoisted_2 = { class: "layout-inner -top-and-bottom" }
const _hoisted_3 = {
  key: 0,
  class: "season-game-detail-container"
}
const _hoisted_4 = { class: "game-detail-nav" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "uil uil-stopwatch icon" }, null, -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode("試合の流れ ")
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "uil uil-file icon" }, null, -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode("スコアを表示 ")
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "uil uil-clipboard-alt icon" }, null, -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" スコアボード ")
const _hoisted_13 = { class: "season-game-detail-content" }
const _hoisted_14 = { class: "game-information" }
const _hoisted_15 = { class: "unit" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "global-label"
}, "ブロック", -1))
const _hoisted_17 = { class: "content" }
const _hoisted_18 = { class: "text" }
const _hoisted_19 = { class: "unit" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "global-label"
}, "マッチNo", -1))
const _hoisted_21 = { class: "unit" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "date",
  class: "global-label"
}, "試合日時", -1))
const _hoisted_23 = { class: "unit" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "global-label"
}, "試合会場", -1))
const _hoisted_25 = { class: "global-select -full-width" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "会場を選択", -1))
const _hoisted_27 = ["value"]
const _hoisted_28 = { class: "unit" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "official",
  class: "global-label"
}, "本部", -1))
const _hoisted_30 = { class: "unit" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "referee",
  class: "global-label"
}, "審判", -1))
const _hoisted_32 = { class: "game-result-container" }
const _hoisted_33 = { class: "team-information" }
const _hoisted_34 = { class: "name" }
const _hoisted_35 = { class: "global-select -full-width" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: undefined }, "ホームを選択", -1))
const _hoisted_37 = ["value", "disabled"]
const _hoisted_38 = {
  key: 0,
  class: "division"
}
const _hoisted_39 = { class: "name" }
const _hoisted_40 = { class: "global-select -full-width" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: undefined }, "アウェイを選択", -1))
const _hoisted_42 = ["value", "disabled"]
const _hoisted_43 = {
  key: 0,
  class: "division"
}
const _hoisted_44 = { class: "score-information" }
const _hoisted_45 = { class: "score-block" }
const _hoisted_46 = { class: "score" }
const _hoisted_47 = { class: "score-form-block" }
const _hoisted_48 = { class: "score-form-unit" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "label" }, "前半", -1))
const _hoisted_50 = { class: "score-form-unit" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "label" }, "後半", -1))
const _hoisted_52 = { class: "score-form-unit" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "label" }, [
  /*#__PURE__*/_createTextVNode("延長"),
  /*#__PURE__*/_createElementVNode("br", { class: "_spDisp" }),
  /*#__PURE__*/_createTextVNode("前半")
], -1))
const _hoisted_54 = { class: "score-form-unit" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "label" }, [
  /*#__PURE__*/_createTextVNode("延長"),
  /*#__PURE__*/_createElementVNode("br", { class: "_spDisp" }),
  /*#__PURE__*/_createTextVNode("後半")
], -1))
const _hoisted_56 = { class: "score-form-unit" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "label" }, "PK", -1))
const _hoisted_58 = { class: "score-block" }
const _hoisted_59 = { class: "score" }
const _hoisted_60 = { class: "score-information-footer" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "global-check-icon" }, null, -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "試合情報を保存", -1))
const _hoisted_63 = [
  _hoisted_61,
  _hoisted_62
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseBreadcrumb = _resolveComponent("BaseBreadcrumb")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BaseBreadcrumb, { breadcrumbs: _ctx.breadcrumbs }, null, 8, ["breadcrumbs"]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.game.data !== undefined)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_router_link, {
                class: "link",
                "data-is-disabled": _ctx.game.data.home_team_id == undefined || _ctx.game.data.away_team_id == undefined,
                to: {
              name: 'seasonGameScore',
              params: { topic_id: _ctx.$route.params.topic_id, season_id: _ctx.$route.params.season_id, game_id: _ctx.$route.params.game_id } }
              }, {
                default: _withCtx(() => [
                  _hoisted_5,
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["data-is-disabled", "to"]),
              _createElementVNode("a", {
                href: _ctx.scoreSheetUrl,
                class: "link link-scoresheet",
                target: "_blank"
              }, _hoisted_10, 8, _hoisted_7),
              _createVNode(_component_router_link, {
                to: {
              name: 'seasonGameScoreboard',
              params: { topic_id: _ctx.$route.params.topic_id, season_id: _ctx.$route.params.season_id, game_id: _ctx.$route.params.game_id } },
                class: "link"
              }, {
                default: _withCtx(() => [
                  _hoisted_11,
                  _hoisted_12
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.groups.group.name), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "global-input -match-id",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.game.data.match_no) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.game.data.match_no]
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "date",
                    class: "global-input",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.game.data.date) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.game.data.date]
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createElementVNode("div", _hoisted_25, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.game.data.field_id) = $event)),
                      class: "select -full-width",
                      onKeydown: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.moveFocusScheduleElement($event, 'right', _ctx.index)), ["right"]))
                    }, [
                      _hoisted_26,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields.list, (field) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: field.id,
                          value: field.id
                        }, _toDisplayString(field.name), 9, _hoisted_27))
                      }), 128))
                    ], 544), [
                      [_vModelSelect, _ctx.game.data.field_id]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "official",
                    class: "global-input",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.game.data.official) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.game.data.official]
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "referee",
                    class: "global-input",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.game.data.refree) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.game.data.refree]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.game.data.home_team_id) = $event)),
                        class: "select -full-width"
                      }, [
                        _hoisted_36,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entries.list, (entry) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: entry.entry_team_id,
                            value: entry.entry_team_id,
                            disabled: entry.entry_team_id === _ctx.game.data.away_team_id
                          }, [
                            _createTextVNode(_toDisplayString(entry.team_short_name) + " ", 1),
                            (entry.division != undefined)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(entry.division), 1))
                              : _createCommentVNode("", true)
                          ], 8, _hoisted_37))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.game.data.home_team_id]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.game.data.away_team_id) = $event)),
                        class: "select -full-width"
                      }, [
                        _hoisted_41,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entries.list, (entry) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: entry.entry_team_id,
                            value: entry.entry_team_id,
                            disabled: entry.entry_team_id === _ctx.game.data.home_team_id
                          }, [
                            _createTextVNode(_toDisplayString(entry.team_short_name) + " ", 1),
                            (entry.division != undefined)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(entry.division), 1))
                              : _createCommentVNode("", true)
                          ], 8, _hoisted_42))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.game.data.away_team_id]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("p", _hoisted_46, _toDisplayString(_ctx.game.data.home_total_score), 1),
                    _withDirectives(_createElementVNode("p", { class: "pk" }, "(" + _toDisplayString(_ctx.game.data.option.home_pk_score) + ")", 513), [
                      [_vShow, _ctx.game.data.option.home_pk_score != null && _ctx.game.data?.option.home_pk_score !== '']
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        min: "0",
                        class: "global-input",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.game.data.option.home_1st_score) = $event)),
                        onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onInputScore('home_1st_score', 'home')))
                      }, null, 544), [
                        [_vModelText, _ctx.game.data.option.home_1st_score]
                      ]),
                      _hoisted_49,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        min: "0",
                        class: "global-input",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.game.data.option.away_1st_score) = $event)),
                        onInput: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onInputScore('away_1st_score', 'away')))
                      }, null, 544), [
                        [_vModelText, _ctx.game.data.option.away_1st_score]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_50, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        min: "0",
                        class: "global-input",
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.game.data.option.home_2nd_score) = $event)),
                        onInput: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onInputScore('home_2nd_score', 'home')))
                      }, null, 544), [
                        [_vModelText, _ctx.game.data.option.home_2nd_score]
                      ]),
                      _hoisted_51,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        min: "0",
                        class: "global-input",
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.game.data.option.away_2nd_score) = $event)),
                        onInput: _cache[15] || (_cache[15] = ($event: any) => (_ctx.onInputScore('away_2nd_score', 'away')))
                      }, null, 544), [
                        [_vModelText, _ctx.game.data.option.away_2nd_score]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_52, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        min: "0",
                        class: "global-input",
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.game.data.option.home_ex_1st_score) = $event)),
                        onInput: _cache[17] || (_cache[17] = ($event: any) => (_ctx.onInputScore('home_ex_1st_score', 'home')))
                      }, null, 544), [
                        [_vModelText, _ctx.game.data.option.home_ex_1st_score]
                      ]),
                      _hoisted_53,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        min: "0",
                        class: "global-input",
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.game.data.option.away_ex_1st_score) = $event)),
                        onInput: _cache[19] || (_cache[19] = ($event: any) => (_ctx.onInputScore('away_ex_1st_score', 'away')))
                      }, null, 544), [
                        [_vModelText, _ctx.game.data.option.away_ex_1st_score]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_54, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        min: "0",
                        class: "global-input",
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.game.data.option.home_ex_2nd_score) = $event)),
                        onInput: _cache[21] || (_cache[21] = ($event: any) => (_ctx.onInputScore('home_ex_2nd_score', 'home')))
                      }, null, 544), [
                        [_vModelText, _ctx.game.data.option.home_ex_2nd_score]
                      ]),
                      _hoisted_55,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        min: "0",
                        class: "global-input",
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.game.data.option.away_ex_2nd_score) = $event)),
                        onInput: _cache[23] || (_cache[23] = ($event: any) => (_ctx.onInputScore('away_ex_2nd_score', 'away')))
                      }, null, 544), [
                        [_vModelText, _ctx.game.data.option.away_ex_2nd_score]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_56, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        min: "0",
                        class: "global-input",
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.game.data.option.home_pk_score) = $event)),
                        onInput: _cache[25] || (_cache[25] = ($event: any) => (_ctx.onInputScore('home_pk_score', 'pk')))
                      }, null, 544), [
                        [_vModelText, _ctx.game.data.option.home_pk_score]
                      ]),
                      _hoisted_57,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        min: "0",
                        class: "global-input",
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.game.data.option.away_pk_score) = $event)),
                        onInput: _cache[27] || (_cache[27] = ($event: any) => (_ctx.onInputScore('away_pk_score', 'pk')))
                      }, null, 544), [
                        [_vModelText, _ctx.game.data.option.away_pk_score]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("p", _hoisted_59, _toDisplayString(_ctx.game.data.away_total_score), 1),
                    _withDirectives(_createElementVNode("p", { class: "pk" }, "(" + _toDisplayString(_ctx.game.data.option.away_pk_score) + ")", 513), [
                      [_vShow, _ctx.game.data.option.away_pk_score != null && _ctx.game.data.option.away_pk_score !== '']
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "global-button",
                    onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.updateGame && _ctx.updateGame(...args)))
                  }, _hoisted_63)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}